/**
 * Translations for the companion feature area.
 * Covers SleepOverlay and PlayGateBlock.
 */
const companion = {
  zh: {
    // SleepOverlay
    'companion.sleep.banner.main': '🌙 仓鼠困了，今天玩到这里吧～',
    'companion.sleep.banner.sub': "The hamster is sleepy. Let's wrap up for today.",
    'companion.sleep.played': '已玩 {minutes} 分钟（上限 {limit}）',
    // Hard sleep block on the play routes (home / chat / zoo)
    'companion.sleep.block.title': '🌙 宠物睡着啦',
    'companion.sleep.block.body': '今天玩够 {limit} 分钟啦，不能再吵 TA 了～\n想继续？去答题、做任务，去赚金币吧！',
    'companion.sleep.block.gotoQuiz': '🧠 去答题',
    'companion.sleep.block.gotoChores': '💰 去赚金币',
    'companion.sleep.block.tomorrow': '明天就能再陪 TA 玩啦 🌞',

    // PlayGateBlock
    'companion.playGate.title': '先完成今日小任务',
    'companion.playGate.helper': '做完爸爸妈妈布置的 {count} 个小任务才能{surface}哦',
    'companion.playGate.surface.chat': '聊天',
    'companion.playGate.surface.shop': '购物',
    'companion.playGate.cta': '🚀 去打卡',
    'companion.playGate.deadline': '{hour}:00 前',
    'companion.playGate.overdue': '已超时 · ',
  },
  en: {
    // SleepOverlay
    'companion.sleep.banner.main': '🌙 The hamster is sleepy — let’s wrap up for today.',
    'companion.sleep.banner.sub': 'Time to rest your little buddy.',
    'companion.sleep.played': 'played {minutes} min (limit {limit})',
    // Hard sleep block on the play routes (home / chat / zoo)
    'companion.sleep.block.title': '🌙 Your pet is asleep',
    'companion.sleep.block.body': "You've played {limit} minutes today — let your buddy rest.\nWant to keep going? Earn coins with quizzes and missions!",
    'companion.sleep.block.gotoQuiz': '🧠 Go answer quizzes',
    'companion.sleep.block.gotoChores': '💰 Earn coins',
    'companion.sleep.block.tomorrow': "You can play together again tomorrow 🌞",

    // PlayGateBlock
    'companion.playGate.title': 'Finish today’s small tasks first',
    'companion.playGate.helper': 'Do {count} small tasks from your parent before you can {surface}',
    'companion.playGate.surface.chat': 'chat',
    'companion.playGate.surface.shop': 'shop',
    'companion.playGate.cta': '🚀 Go check in',
    'companion.playGate.deadline': 'before {hour}:00',
    'companion.playGate.overdue': 'overdue · ',
  },
};

export default companion;
